<template>
  <Layout ref="pageRef">
    <template v-slot:navigation>
      <Navigation :transparent="transparent" :showMenu="true">
        <template v-slot:title>
          <!-- <router-link class="title" to="/">Samsung Eco-package</router-link> -->
          <span class="title" @click="HomeLink()">
              Samsung Upcycle-Packaging
              <!-- {{ $t("LandingPage.title") }} -->
            </span>
        </template>
      </Navigation>
    </template>
    <template v-slot:content>
      <div>
        <div ref="navigationTriggerRef"></div>
        <BoxList
          :categoryKey="categoryKey"
          :cover="model.cover"
          :box="model.box"
          :dezeenBox="Object.keys(model.dezeenBox).length != 0 ? model.dezeenBox : null"
          :worldcup="Object.keys(model.worldcup).length != 0 ? model.worldcup : null"
          :disney="Object.keys(model.disney).length != 0 ? model.disney : null"
        />
      </div>
    </template>
    <template v-slot:footer>
      <Footer />
    </template>
  </Layout>
</template>

<script>
import Navigation from "../style/Navigation.vue";
import Footer from "../style/Footer.vue";
import Layout from "../style/Layout.vue";
import BoxList from "../style/BoxList/index";
import OverdriveKey from "@/models/overdrive/Landing_Category";
import { CategoryLists } from "@/models/CategoryKey";
import { categories } from "@/models/categories";
import * as ScrollMagic from "scrollmagic";
import * as easing from "eases/quart-in-out";

export default {
  components: {
    Navigation,
    Footer,
    Layout,
    BoxList,
  },
  created() {
    this.LoadImage();
  },
  data() {
    return {
      easing,
      OverdriveKey,
      categoryKey: undefined,
      model: undefined,
      transparent: true,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$nextTick(() => {
      const controller = new ScrollMagic.Controller();
      new ScrollMagic.Scene({
        triggerElement: this.$refs.navigationTriggerRef,
        triggerHook: 0,
        duration: 0,
        offset: 768,
      })
        .on("enter", () => {
          this.transparent = false;
        })
        .on("leave", () => {
          this.transparent = true;
        })
        .addTo(controller);
    });
    // navigationTriggerRef;
  },
  methods: {
    LoadImage() {
      this.categoryKey =
        this.$route.params.category ?? CategoryLists.Lifestyle.list.Serif;

      this.model = categories[this.categoryKey];
      console.log("!!!!!!!!!!!!!!!!!!",this.model)
      if (this.model === undefined) this.$router.push({ path: `/404` });
    },
     HomeLink(){
      // this.$router.go(this.$router.currentRoute);
      window.sessionStorage.setItem("introFlag", true);
      this.$router.push('/')
      
    }
  },
};
</script>

<style scoped>
.title {
  font-weight: 700;
  cursor: pointer;
}
</style>
